import React from "react";
import ColFormValueSlider from "./ColFormValueSlider";
import { useController, useFormContext } from "react-hook-form";
import ControlledFormField from "@/model/interface/ControllerRangeSlider";
import { CalculatorField } from "@/model/interface/CalculatorTypes";

const getPercentageFields = () => {
  return {
    defaultValue: 40,
    minAmount: 25,
    maxAmount: 50,
  };
};

const fieldName = CalculatorField.HelpPercentage;

const MortgageHelpPercentage: React.FC<ControlledFormField> = function ({ fieldPrefix }) {
  const { control } = useFormContext();
  const { defaultValue, ...minMaxParams } = getPercentageFields();

  const { field } = useController({
    control,
    name: [fieldPrefix, fieldName].filter(Boolean).join("."),
    defaultValue,
  });

  return (
    <ColFormValueSlider
      title="Fintree help percentage"
      step={1}
      value={field.value}
      {...minMaxParams}
      rightColumnValue={field.value}
      rightColumnFormatFunction={(value) => `${value}%`}
      onFinalChange={field.onChange}
      onChange={field.onChange}
    />
  );
};

export default MortgageHelpPercentage;
